// https://gist.github.com/ccheney/957481d88a5060ab4bb3401cdee296ac
import axios from 'axios';
import httpInterceptor from './interceptor.js';

const isDev = process.env.NODE_ENV === 'development';
const opts = {
  baseURL: isDev ? '/api' : '/hxcota',
};
const instance = axios.create(opts);

httpInterceptor.setupInterceptors(instance);

export default instance;
